<style/styles: any>
  .home {
    text-align: right;
    margin-top: 4rem;

    a {
      text-decoration: none;
      color: light-dark(rgb(203, 167, 138), rgb(109, 72, 42));
      @media (hover: hover) {
        &:hover > span {
          text-decoration: underline;
        }
      }
      &:focus > span {
        text-decoration: underline;
      }
    }
  }
</style>

div class=styles.home
  a href="/"
    -- ←${" "}
    span -- lavalva.dev